"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFunction = void 0;
var isFunction = function (val) {
    return typeof val === 'function';
};
exports.isFunction = isFunction;
//# sourceMappingURL=function.js.map